import { SentryEnvironment } from '@techniek-team/sentry-web';
import { EnvironmentModel } from './environment.model';

const baseAppUrl: string = 'https://alfred-dashboard.kube.techniek-team.nl/';

export const environment: EnvironmentModel = {
  production: true,
  environment: SentryEnvironment.ACCEPTANCE,
  release: '4.2.0-develop.1',
  sentryDsn:
    'https://09796c770e0d41778eb44f2f129b63c6@errors.techniek-team.nl/113',
  authConfig: {
    issuer: 'https://login.kube.techniek-team.nl/realms/sso',
    clientId: 'alfred-dashboard-acceptance',
    responseType: 'code',
    redirectUri: baseAppUrl,
    postLogoutRedirectUri: baseAppUrl,
    scope: 'openid profile email offline_access',
    showDebugInformation: false,
    clearHashAfterLogin: true,
    nonceStateSeparator: 'semicolon',
  },
  authModuleConfig: {
    resourceServer: {
      allowedUrls: [
        'https://ly-al-api.acc.techniek-team.nl',
        'https://lyceo-bieb.kube.acc.techniek-team.nl',
      ],
      sendAccessToken: true,
    },
  },
  alfredApi: 'https://ly-al-api.acc.techniek-team.nl',
  biebApi: 'https://lyceo-bieb.kube.techniek-team.nl',
  baseUrl: baseAppUrl,
};
